module.exports = __webpack_public_path__ + "static/media/infantsicon.7c4acf1a.svg";